module.exports = __webpack_public_path__ + "img/icon_e13.b2a985d7.png";